<template>
  <div class="page">
    <page-header :mode="navBarMode" />
    <div class="page-body">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </div>

    <fix-tool />

    <page-footer ref="pageFooter" />
  </div>
</template>

<script>
// 组件
import PageHeader from '@/layout/components/PageHeader'
import PageFooter from '@/layout/components/PageFooter'
import FixTool from '@/layout/components/FixTool'

export default {
  name: 'HomeLayout',

  components: { PageHeader, PageFooter, FixTool },

  data() {
    return {
      navBarMode: 'transparent'
    }
  },

  computed: {
    cachedViews() {
      return this.$store.state.cacheView.cachedViews
    },

    key() {
      return this.$route.path
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('scroll', this.handleScroll)
    })
  },

  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop >= 50) {
        this.navBarMode = 'default'
      } else {
        this.navBarMode = 'transparent'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-width: $body-width;
  min-height: 100vh;
  position: relative;

  .page-body {
    min-height: calc(100vh - #{$header-height});
  }
}
</style>
